import React from "react";
import CvLayoutEngine from "./cvLayoutEngine";
import { QUILL_HIGHLIGHT_SUPPORT_CSS } from "./resumeRichText";
import { useResumeStore } from "../../store/resumeStore";
import {
  MintCompactTemplate,
} from "./templates/SampleInspiredTemplates";
import {
  ExperiencedExecutiveOrbitTemplate,
  FresherMintGridTemplate,
  FresherNordicTemplate,
} from "./templates/PrototypeProductionTemplates";
import { NEW_PROTOTYPE_TEMPLATE_COMPONENTS } from "./templates/NewPrototypeTemplates";
import LegacyTemplateCompleteness from "./LegacyTemplateCompleteness";

const TEMPLATE_COMPONENTS = {
  template7: MintCompactTemplate,
  template12: FresherNordicTemplate,
  template13: FresherMintGridTemplate,
  template15: ExperiencedExecutiveOrbitTemplate,
  ...NEW_PROTOTYPE_TEMPLATE_COMPONENTS,
};

export function renderTemplateById(templateId) {
  const TemplateComponent = TEMPLATE_COMPONENTS[templateId];

  if (TemplateComponent) {
    return <TemplateComponent />;
  }

  return <FresherNordicTemplate />;
}

export default function TemplateRenderer({ templateId }) {
  const resumeData = useResumeStore((state) => state.resume);

  return (
    <CvLayoutEngine templateId={templateId} resumeData={resumeData}>
      <style>{QUILL_HIGHLIGHT_SUPPORT_CSS}</style>
      {renderTemplateById(templateId)}
      <LegacyTemplateCompleteness templateId={templateId} />
    </CvLayoutEngine>
  );
}
